/* eslint-disable no-underscore-dangle */
export const MOCK_AUTH = window._env_.MOCK_AUTH === 'true';
export const MOCK_USER_ROLE = window._env_.MOCK_ROLE;
export const API_URL = window._env_.API_BASE_URL;
export const COMPLETION_REDIRECT_URL = undefined;

export const ASSESSMENTS = {
  FLASH_CARD_INTERVAL: 1000, // milliseconds
  SYMMETRY_GRID_INTERVAL: 3000,
  LETTER_FLASH_INTERVAL: 1500,
  MATH_FLASH_INTERVAL: 2000,
  DISPLAY_RESULTS_INTERVAL: 2000,
};

export const ROLES = {
  ASSESSMENT_USER: 'assessment-user',
  CLIENT_USER: 'client-user',
  EMPLOYEE_USER: 'employee-user',
};

export const PARTICIPATION_PATHS = {
  COMPLETE: 'complete',
  NOT_STARTED: 'not-started',
  IN_PROGRESS: 'in-progress',
};
